import SBPLogoRaiffeisen from './SBPLogoRaiffeisen';

export default SBPLogoRaiffeisen;
